module.exports = __webpack_public_path__ + "801965b0436842e843141a5a6c1e387f.ttf";